export default __webpack_public_path__ + "static/media/platziExchangeImg_1.6cc47c2d.png";